module.exports = __webpack_public_path__ + "static/media/users.e839d674.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/users.svg
// module id = 832
// module chunks = 21